module.exports = __webpack_public_path__ + "static/img/shapan1.fb3ed7be.png";